export type Scorer = { playerId: string; name: string; teamId: string | null; goals: number }

/** Cannonieri: ogni evento bicchiere conta uno, tiri del pareggio compresi; giocatori sconosciuti ignorati. */
export function topScorers(events: readonly { scorerId: string }[], players: readonly { id: string; name: string; teamId: string | null }[]): Scorer[] {
  const goals = new Map<string, number>()
  for (const e of events) goals.set(e.scorerId, (goals.get(e.scorerId) ?? 0) + 1)
  return players
    .filter((p) => goals.has(p.id))
    .map((p) => ({ playerId: p.id, name: p.name, teamId: p.teamId, goals: goals.get(p.id)! }))
    .sort((a, b) => b.goals - a.goals || a.name.localeCompare(b.name))
}

function countBy<K extends string>(events: readonly Record<K, string>[], key: K): Map<string, number> {
  const counts = new Map<string, number>()
  for (const e of events) counts.set(e[key], (counts.get(e[key]) ?? 0) + 1)
  return counts
}

export const countAirballsByPlayer = (events: readonly { playerId: string }[]) => countBy(events, 'playerId')
export const countAirballsByTeam = (events: readonly { teamId: string }[]) => countBy(events, 'teamId')
